<template>
  <v-layout class="fill-height">
    <v-app-bar class="header pl-5" elevation="0"> Header </v-app-bar>

    <v-navigation-drawer class="side-menu pt-5 pl-5">
      Side menu
    </v-navigation-drawer>

    <v-main class="main-container">
      <div class="fill-height d-flex flex-column px-8 py-3 padded-row">
        <div class="flex-grow-0 pb-3 navigation-buttons">
          Back button and questionnaire progress bar
        </div>

        <div class="flex-grow-1 nested-row">
          <v-card class="card fill-height pa-6">Card content</v-card>
        </div>

        <div class="footer flex-grow-0 text-center pt-12"></div>
      </div>
    </v-main>
  </v-layout>
</template>

<style scoped lang="scss">
.header {
  background-color: gold !important;
}

.side-menu {
  background-color: #cccccc;
  max-width: 255px;
}

.navigation-buttons {
  background-color: aqua;
}
.padded-row {
  background-color: red;
}
.footer {
  min-height: 64px;
  background-color: green;
  min-width: 100%;
}

.main-container {
  background-color: orange;
}
.nested-row {
  background-color: lightblue;
}
</style>
